import { isAxiosError } from 'axios';

export const extractApiErrorMessage = (
  error: unknown,
  fallback = 'Ocorreu um erro inesperado.',
) => {
  if (isAxiosError(error)) {
    const message = error.response?.data?.message;

    if (typeof message === 'string' && message.trim()) {
      return message;
    }

    if (Array.isArray(message) && message.length > 0) {
      return message.join(', ');
    }
  }

  if (error instanceof Error && error.message.trim()) {
    return error.message;
  }

  return fallback;
};
